var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryOthers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.833 21.6666L12.1404 24.2814C12.5829 25.1664 12.8042 25.6089 13.0997 25.9923C13.362 26.3326 13.667 26.6376 14.0073 26.8999C14.3907 27.1954 14.8332 27.4167 15.7181 27.8592L18.333 29.1666L15.7181 30.474C14.8332 30.9165 14.3907 31.1377 14.0073 31.4333C13.667 31.6956 13.362 32.0006 13.0997 32.3408C12.8042 32.7243 12.5829 33.1668 12.1404 34.0517L10.833 36.6666L9.52558 34.0517C9.0831 33.1668 8.86185 32.7243 8.56629 32.3408C8.30402 32.0006 7.999 31.6956 7.65875 31.4333C7.27532 31.1377 6.83283 30.9165 5.94787 30.474L3.33301 29.1666L5.94787 27.8592C6.83283 27.4167 7.27531 27.1954 7.65875 26.8999C7.999 26.6376 8.30402 26.3326 8.56629 25.9923C8.86185 25.6089 9.0831 25.1664 9.52558 24.2814L10.833 21.6666Z",
    stroke: "#6374A6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9997 3.33325L26.964 8.44062C27.4341 9.66267 27.6691 10.2737 28.0345 10.7877C28.3584 11.2432 28.7564 11.6412 29.2119 11.9651C29.7259 12.3305 30.3369 12.5655 31.559 13.0355L36.6663 14.9999L31.559 16.9643C30.3369 17.4343 29.7259 17.6693 29.2119 18.0348C28.7564 18.3587 28.3584 18.7567 28.0345 19.2122C27.6691 19.7261 27.4341 20.3372 26.964 21.5592L24.9997 26.6666L23.0353 21.5592C22.5653 20.3372 22.3303 19.7261 21.9648 19.2122C21.6409 18.7567 21.2429 18.3587 20.7874 18.0348C20.2734 17.6693 19.6624 17.4343 18.4404 16.9643L13.333 14.9999L18.4404 13.0355C19.6624 12.5655 20.2734 12.3305 20.7874 11.9651C21.2429 11.6412 21.6409 11.2432 21.9648 10.7877C22.3303 10.2737 22.5653 9.66267 23.0353 8.44062L24.9997 3.33325Z",
    stroke: "#6374A6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryOthers);
export default __webpack_public_path__ + "react/media/category-others.67f54f55e90153efe8ec338d367efb64.svg";
export { ForwardRef as ReactComponent };